export enum ChainEnvironment {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

export interface ChainInfo {
  scannerUrl: string
  environment: ChainEnvironment
}

export const CHAIN_INFO: Record<string, ChainInfo> = {
  84532: {
    scannerUrl: 'https://sepolia.basescan.org',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  33111: {
    scannerUrl: 'https://curtis.explorer.caldera.xyz/',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  421614: {
    scannerUrl: 'https://sepolia.arbiscan.io',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  59140: {
    scannerUrl: 'https://sepolia.lineascan.build',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  5003: {
    scannerUrl: 'https://explorer.testnet.mantle.xyz',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  80002: {
    scannerUrl: 'https://amoy.polygonscan.com',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  1301: {
    scannerUrl: 'https://unichain.blockscout.com/',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  11155111: {
    scannerUrl: 'https://sepolia.etherscan.io',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  10200: {
    scannerUrl: 'https://blockscout.com/gnosis/chiado',
    environment: ChainEnvironment.DEVELOPMENT,
  },
  8453: {
    scannerUrl: 'https://basescan.org',
    environment: ChainEnvironment.PRODUCTION,
  },
  33139: {
    scannerUrl: 'https://apescan.io',
    environment: ChainEnvironment.PRODUCTION,
  },
  42161: {
    scannerUrl: 'https://arbiscan.io',
    environment: ChainEnvironment.PRODUCTION,
  },
  59144: {
    scannerUrl: 'https://lineascan.build',
    environment: ChainEnvironment.PRODUCTION,
  },
  5000: {
    scannerUrl: 'https://explorer.mantle.xyz',
    environment: ChainEnvironment.PRODUCTION,
  },
  137: {
    scannerUrl: 'https://polygonscan.com',
    environment: ChainEnvironment.PRODUCTION,
  },
  130: {
    scannerUrl: 'https://unichain.blockscout.com/',
    environment: ChainEnvironment.PRODUCTION,
  },
  88888: {
    scannerUrl: 'https://scan.chiliz.com',
    environment: ChainEnvironment.PRODUCTION,
  },
  42220: {
    scannerUrl: 'https://celoscan.io',
    environment: ChainEnvironment.PRODUCTION,
  },
  1: {
    scannerUrl: 'https://etherscan.io',
    environment: ChainEnvironment.PRODUCTION,
  },
  100: {
    scannerUrl: 'https://gnosisscan.io',
    environment: ChainEnvironment.PRODUCTION,
  },
  10: {
    scannerUrl: 'https://optimistic.etherscan.io',
    environment: ChainEnvironment.PRODUCTION,
  },
}

export const getChainScannerUrl = (chainName: number): string => {
  return CHAIN_INFO[chainName]?.scannerUrl || ''
}

export const isChainDevelopment = (chainName: string): boolean => {
  return CHAIN_INFO[chainName]?.environment === ChainEnvironment.DEVELOPMENT
}

export const isChainProduction = (chainName: string): boolean => {
  return CHAIN_INFO[chainName]?.environment === ChainEnvironment.PRODUCTION
}

export const getTransactionUrl = (chainId: number, txHash: string): string => {
  const baseUrl = getChainScannerUrl(chainId)
  if (!baseUrl || !txHash) return ''

  return `${baseUrl}/tx/${txHash}`
}
